module.exports = __webpack_public_path__ + "cef894f4492b226ab728fb340dc71cad.svg";